// File Upload Helper Functions
// Extracted from Moodboard Matcher for reusable file handling
// Part 1: Core Upload and Remove

// Handle image upload with validation
export const handleImageUpload = (files, selectedImages, setSelectedImages, setError) => {
  const fileArray = Array.from(files);
  if (fileArray.length + selectedImages.length > 3) {
    setError('Maximum 3 images allowed');
    return;
  }

  const imageObjects = fileArray.map(file => ({
    file,
    preview: URL.createObjectURL(file),
    name: file.name
  }));

  setSelectedImages(prev => [...prev, ...imageObjects]);
  setError(null);
};

// Remove image from selection
export const removeImage = (index, selectedImages, setSelectedImages) => {
  const newImages = selectedImages.filter((_, i) => i !== index);
  setSelectedImages(newImages);
};

// Handle drag and drop
export const handleDrop = (e, setDragActive, handleImageUpload) => {
  e.preventDefault();
  setDragActive(false);
  handleImageUpload(e.dataTransfer.files);
};

// Handle drag over
export const handleDragOver = (e, setDragActive) => {
  e.preventDefault();
  setDragActive(true);
};

// Handle drag leave
export const handleDragLeave = (e, setDragActive) => {
  e.preventDefault();
  setDragActive(false);
};
